"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

import BookingModal from "../modal/booking-modal";
import Link from "next/link";

export default function CTA() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  return (
    <>
      <section
        className="py-12 sm:py-16 lg:py-20 relative overflow-hidden"
        style={{
          background: `
          radial-gradient(500px 200px at 30% 0%, rgba(242,166,90,0.35), transparent 60%),
          radial-gradient(500px 200px at 70% 100%, rgba(122,111,240,0.35), transparent 60%),
          #0B0B0F
        `
        }}
      >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:flex lg:gap-12 lg:items-start">
            {/* Left Column */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.32 }}
              className="lg:w-[58%] mb-8 lg:mb-0"
            >
              <h2 className="text-2xl sm:text-[28px] md:text-[34px] lg:text-[40px] text-white mb-4" style={{ fontWeight: 500, lineHeight: 1.15, letterSpacing: "-0.02em" }}>
                Ready to Build a System That Scales?
              </h2>
              <p className="text-base sm:text-[17px] text-white/70 mb-4 sm:mb-6" style={{ fontWeight: 400, lineHeight: 1.6 }}>
                Whether you're starting from scratch or improving an existing product, we can help you build software that supports your growth.
              </p>
              <p className="text-sm sm:text-[15px] text-white/60" style={{ fontWeight: 400, lineHeight: 1.7 }}>
                Every engagement starts with a conversation. We'll discuss your goals, constraints, and what success looks like for your project.
              </p>
            </motion.div>

            {/* Right Column - CTA Panel */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.32, delay: 0.1 }}
              className="lg:w-[42%]"
            >
              <div className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-sm p-6 sm:p-8">
                <p className="text-[11px] sm:text-[12px] uppercase tracking-wide text-[#7A6FF0] mb-4 sm:mb-6 text-center" style={{ fontWeight: 500 }}>
                  Next Step
                </p>
                <p className="text-sm sm:text-[14px] text-white/70 mb-4 sm:mb-6 text-center" style={{ fontWeight: 400, lineHeight: 1.6 }}>
                  Schedule a free consultation to discuss your project requirements.
                </p>

                <motion.button
                  onClick={() =>
                    setIsBookingModalOpen(true)
                  }
                  whileHover={{ y: -2 }}
                  transition={{ duration: 0.16 }}
                  className="w-full inline-flex items-center justify-center rounded-full bg-white px-6 py-3 text-sm sm:text-[15px] font-semibold text-[#0B0B0F] transition-all duration-200 hover:bg-white/90 hover:shadow-lg hover:shadow-white/10 mb-4"
                >
                  Book a Free Consultation
                  <ArrowRight className="ml-2 h-4 w-4" />
                </motion.button>

                <div className="flex items-center justify-center gap-3 sm:gap-4">
                  <Link href={'/contact'}> <button

                    className="text-sm cursor-pointer sm:text-[14px] text-white/70 hover:text-white transition-colors"
                    style={{ fontWeight: 500 }}
                  >
                    Contact Us
                  </button></Link>
                  <span className="text-white/30">·</span>
                  <a
                    href="mailto:hello@zysoftec.com"
                    className="text-sm sm:text-[14px] text-white/70 hover:text-white transition-colors"
                    style={{ fontWeight: 500 }}
                  >
                    Email Us
                  </a>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <BookingModal
        open={isBookingModalOpen}
        onClose={() =>
          setIsBookingModalOpen(false)
        }
      />
    </>
  );
}



